import React from "react"
import { Box, AspectRatio } from "@chakra-ui/layout"

export default function EzyVetGlobalSupportGroupVidyardVideo() {
    return (
        <AspectRatio ratio={16 / 9} maxW={640} mt={8}>
            <Box
                as="img"
                w="100%"
                margin="auto"
                display="block"
                className="vidyard-player-embed"
                src="https://play.vidyard.com/oMpt2wdUH9TsiktaU4CwsB.jpg"
                data-uuid="oMpt2wdUH9TsiktaU4CwsB"
                data-v="4"
                data-type="inline"
            />
        </AspectRatio>
    )
}
